import { useEffect, useState } from 'react'
import { RoomDetailsApi, UpdateRoomApi } from '../../services/Api';
import { isAdmin, isAuthenticated } from '../../services/Auth';
import { toast } from 'react-toastify';
import { Navigate, useParams } from 'react-router-dom';


export default function UpdateRoom() {


  const [inputs, setInputs] = useState({
    name: "",
    price: "",
    description: "",
    ratings: "",
    image1: "",
    image2: "",
    image3: "",
    image4: "",
    image5: "",
    category: "select",
    ac: "select",
    wifi: "select",
    tv: "select",
    heater: "select",
    vacancies: ""
  })


  const initialStateErrors = {
    name: false,
    price: false,
    description: false,
    ratings: false,
    image1: false,
    image2: false,
    image3: false,
    image4: false,
    image5: false,
    category: false,
    ac: false,
    wifi: false,
    tv: false,
    heater: false,
    vacancies: false,
    custom_error: null
  };
  const [errors, setErrors] = useState(initialStateErrors);

  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    if (isAuthenticated() && isAdmin()) {

      RoomDetailsApi(id).then((response) => {
        setInputs(values => ({
          ...values,
          name: response.data.room.name,
          price: response.data.room.price,
          description: response.data.room.description,
          ratings: response.data.room.ratings,
          image1: response.data.room.images[0].image,
          image2: response.data.room.images[1].image,
          image3: response.data.room.images[2].image,
          image4: response.data.room.images[3].image,
          image5: response.data.room.images[4].image,
          category: response.data.room.category,
          ac: response.data.room.ac,
          wifi: response.data.room.wifi,
          tv: response.data.room.tv,
          heater: response.data.room.heater,
          vacancies: response.data.room.vacancies
        }));
      })
    }
  }, [id])



  const handleSubmit = (event) => {
    event.preventDefault();
    let errors = initialStateErrors;
    let hasError = false;
    if (inputs.name === "") {
      errors.name = true;
      hasError = true;
    }
    if (inputs.price === "") {
      errors.price = true;
      hasError = true;
    }
    if (inputs.description === "") {
      errors.description = true;
      hasError = true;
    }
    if (inputs.ratings < "1" || inputs.ratings > "5") {
      errors.ratings = true;
      hasError = true;
    }
    if (inputs.image1 === "") {
      errors.image1 = true;
      hasError = true;
    }
    if (inputs.image2 === "") {
      errors.image2 = true;
      hasError = true;
    }
    if (inputs.image3 === "") {
      errors.image3 = true;
      hasError = true;
    }
    if (inputs.image4 === "") {
      errors.image4 = true;
      hasError = true;
    }
    if (inputs.image5 === "") {
      errors.image5 = true;
      hasError = true;
    }
    if (inputs.category === "select") {
      errors.category = true;
      hasError = true;
    }
    if (inputs.ac === "select") {
      errors.ac = true;
      hasError = true;
    }
    if (inputs.wifi === "select") {
      errors.wifi = true;
      hasError = true;
    }
    if (inputs.tv === "select") {
      errors.tv = true;
      hasError = true;
    }
    if (inputs.heater === "select") {
      errors.heater = true;
      hasError = true;
    }
    if (inputs.vacancies === "") {
      errors.vacancies = true;
      hasError = true;
    }
    if (!hasError && isAuthenticated() && isAdmin()) {
      setLoading(true)
      async function api() {
        try {
          UpdateRoomApi(inputs, id);
          toast.success("Room Updated Successfully");
        } catch (err) {
          setErrors(values => ({ ...values, custom_error: err }))
        } finally {
          setLoading(false)
        }
      }
      api();
    }
    setErrors(errors);
  }


  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({ ...values, [name]: value }))
  }

  function handleReset() {
    setInputs({
      name: "",
      price: "",
      description: "",
      ratings: "",
      image1: "",
      image2: "",
      image3: "",
      image4: "",
      image5: "",
      category: "select",
      ac: "select",
      wifi: "select",
      tv: "select",
      heater: "select",
      vacancies: ""
    })
    toast.info("Reset Successfully");
  }

  if (!isAuthenticated() || !isAdmin()) {
    return <Navigate to="/login" />
  }

  return (
    <>
      <div className="row min-vw-100 min-vh-100 justify-content-center align-items-center bgpic">
        <div className="col-11 col-sm-8 col-md-7 col-lg-6 col-xl-5">

          <div className="d-flex flex-column justify-content-center align-items-center w-100 p-5 rounded-5 bg-body-tertiary bg-opacity-50">
            <div className='text-center h2'>Update Room</div>
            <form className="w-100" onSubmit={handleSubmit}>

              <div className="w-100 mt-3">
                <label htmlFor="name" className="form-label">Room Name</label>
                <input type="text" className="form-control" name="name" value={inputs.name} id="name" onChange={handleChange} placeholder="Enter Room Name" />
                {errors.name ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Name is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="price" className="form-label">Room Price</label>
                <input type="number" className="form-control" id="price" name="price" value={inputs.price} onChange={handleChange} placeholder="Enter Room Price" />
                {errors.price ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Price is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="description" className="form-label">Room Description</label>
                <textarea className="form-control" name="description" value={inputs.description} id="description" onChange={handleChange} placeholder="Enter your room description"></textarea>
                {errors.description ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Description is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="ratings" className="form-label">Ratings</label>
                <input type="number" className="form-control" id="ratings" name="ratings" value={inputs.ratings} onChange={handleChange} placeholder="Enter Room Ratings" />
                {errors.ratings ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Ratings is required 1 to 5.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="image1" className="form-label">Room Image 1 URL</label>
                <input type="url" className="form-control" id="image1" name="image1" value={inputs.image1} onChange={handleChange} placeholder="Enter Room images URL" />
                {errors.image1 ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Images URL is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="image2" className="form-label">Room Image 2 URL</label>
                <input type="url" className="form-control" id="image2" name="image2" value={inputs.image2} onChange={handleChange} placeholder="Enter Room images URL" />
                {errors.image2 ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Images URL is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="image3" className="form-label">Room Image 3 URL</label>
                <input type="url" className="form-control" id="image3" name="image3" value={inputs.image3} onChange={handleChange} placeholder="Enter Room images URL" />
                {errors.image3 ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Images URL is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="image4" className="form-label">Room Image 4 URL</label>
                <input type="url" className="form-control" id="image4" name="image4" value={inputs.image4} onChange={handleChange} placeholder="Enter Room images URL" />
                {errors.image4 ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Images URL is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="image5" className="form-label">Room Image 5 URL</label>
                <input type="url" className="form-control" id="image5" name="image5" value={inputs.image5} onChange={handleChange} placeholder="Enter Room images URL" />
                {errors.image5 ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Images URL is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="category" className="form-label">Room Category</label>
                <select className='form-select' id="category" name="category" value={inputs.category} onChange={handleChange}>
                <option value="select">Select Category</option>
                  <option value="Single Bedroom">Single Bedroom</option>
                  <option value="Double Bedroom">Double Bedroom</option>
                  <option value="Triple Bedroom">Triple Bedroom</option>
                  <option value="Single Bed Dulex">Single Bed Dulex</option>
                  <option value="Premium">Premium</option>
                </select>
                {errors.category ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Category is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="ac" className="form-label">AC</label>
                <select className='form-select' id="ac" name="ac" value={inputs.ac} onChange={handleChange}>
                  <option value="select">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {errors.ac ?
                  (<span className="text-danger bg-warning-subtle" >
                    AC is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="wifi" className="form-label">WIFI</label>
                <select className='form-select' id="wifi" name="wifi" value={inputs.wifi} onChange={handleChange}>
                  <option value="select">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {errors.wifi ?
                  (<span className="text-danger bg-warning-subtle" >
                    WIFI is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="tv" className="form-label">TV</label>
                <select className='form-select' id="tv" name="tv" value={inputs.tv} onChange={handleChange}>
                  <option value="select">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {errors.tv ?
                  (<span className="text-danger bg-warning-subtle" >
                    TV is required.
                  </span>) : null
                }
              </div>

              <div className="w-100 mt-3">
                <label htmlFor="heater" className="form-label">Heater</label>
                <select className='form-select' id="heater" name="heater" value={inputs.heater} onChange={handleChange}>
                  <option value="select">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {errors.heater ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room Heater is required.
                  </span>) : null
                }
              </div>



              <div className="w-100 mt-3">
                <label htmlFor="vacancies" className="form-label">Room Vacancies</label>
                <input type="number" className="form-control" id="vacancies" name="vacancies" value={inputs.vacancies} onChange={handleChange} placeholder="Enter Room Vacancies" />
                {errors.vacancies ?
                  (<span className="text-danger bg-warning-subtle" >
                    Room vacancies is required.
                  </span>) : null
                }
              </div>


              <div className="mt-3 text-center">
                <span>
                  {errors.custom_error ?
                    (<p className="text-danger bg-warning-subtle rounded-5">{errors.custom_error}</p>)
                    : null
                  }
                </span>
                {loading ?
                  (<div className="text-center">
                    <div className="spinner-border text-primary " role="status">
                    </div>
                  </div>) : null
                }

                <button className="btn btn-primary me-5" type="submit" disabled={loading}>Submit</button>
                <button className="btn btn-danger" type="reset" onClick={handleReset}>Reset</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}